//메뉴 관리
import MenuManagementContainer from './Menu/MenuManagementContainer';

//권한 관리
import PrivilegeManagementContainer from './Privilege/PrivilegeManagementContainer';
export const AuthIndex = {
  MenuManagementContainer,
  PrivilegeManagementContainer,
};
